import React, { useContext, useState } from "react";
import { order } from "assets/dummyData/clusterData";

export const VIEW_TYPES = {
  PUBLIC: "public",
  PRIVATE: "private",
};

export const ACCOUNT_TYPES = {
  ADMIN: {
    authenticated: true,
    type: "admin",
    viewMode: VIEW_TYPES.PRIVATE,
  },
  RECRUITER: {
    authenticated: true,
    type: "recruiter",
    viewMode: VIEW_TYPES.PRIVATE,
  },
  EMPLOYER: {
    authenticated: true,
    type: "employer",
    viewMode: VIEW_TYPES.PUBLIC,
  },
  EMPLOYER_PUBLIC: {
    authenticated: false,
    type: "employer_public",
    viewMode: VIEW_TYPES.PUBLIC,
  },
  EMPLOYER_PRIVATE: {
    authenticated: true,
    type: "employer_private",
    viewMode: VIEW_TYPES.PRIVATE,
  },
  JOB_SEEKER: {
    authenticated: false,
    type: "job_seeker",
    viewMode: VIEW_TYPES.PUBLIC,
  },
  PUBLIC: {
    authenticated: false,
    type: "public",
    viewMode: VIEW_TYPES.PUBLIC,
  },
};

const initialState = {};

const AppContext = React.createContext(initialState);

export function AppContextProvider(props) {
  const [orders] = useState(Array(10).fill(order));
  console.log("CONTEXT -- orders: ", orders);

  const selectedRecruiter = "@florianlaurent";
  const selectedCluster = "@amazon-kf4otdk9";
  const selectedOrderName = "@software-engineer-1wlq1q09";

  // ---------------------------------------------------
  // INPUT - Control the Current Account Mode
  const currentAccount = ACCOUNT_TYPES.ADMIN;
  // ---------------------------------------------------

  const account = {
    isAuthenticated: currentAccount.authenticated,
    accountId: "123",
    accountToken: "a0smcvd48vrmusava90nvd0",
    accountType: {
      type: currentAccount.type,
      viewType: currentAccount.viewMode,
    },
    firstName: "Eduardo",
    lastName: "Garza",
  };

  const currentUser = {
    firstName: "Evan",
    lastName: "Morrison",
    companyName: "Amazon",
    companyURL: "https://www.amazon.ca",
    jobTitle: "CTO",
    email: "evan@amazon.com",
    phone: "(123) 456-7890",
    linkedinURL: "https://www.linkedin.com/in/evanmorrison",
    twitterURL: "https://twitter.com/evanmorrison",
  };

  // const [channels, setChannels] = useState([])
  // const [snapshots, setSnapshots] = useState([])

  // async function fetchData() {
  //   const baseURL = getBaseURL()
  //   const channelsURL = `${baseURL}/channels`
  //   const response = await axios.get(channelsURL)
  //   const channels = response.data
  //   const snapshots = channels[0].snapshots.map(v => v.timestamp)
  //   setSnapshots(snapshots)
  //   const formattedChannels = channels.map(c => ({
  //     ...c,
  //     snapshots: c.snapshots.map(s => ({
  //       ...s,
  //       videos: Number(s.videos),
  //       subscribers: Number(s.subscribers),
  //       views: Number(s.views),
  //       subsPerVideo: Math.round(Number(s.subscribers) / Number(s.videos)),
  //       viewsPerVideo: Math.round(Number(s.views) / Number(s.videos)),
  //     }))
  //   }))
  //   setChannels(formattedChannels)
  // }

  // useEffect(() => {
  // fetchData()
  // }, [])

  const selectedOrder = orders[0];

  const context = {
    account,
    selectedRecruiter,
    selectedCluster,
    selectedOrderName,
    currentUser,
    orders,
    selectedOrder,
  };

  return <AppContext.Provider value={context}>{props.children}</AppContext.Provider>;
}

export default function useAppContext() {
  return useContext(AppContext);
}
